
import ProductBrandListComponent from "../../../components/product_brands/Index.vue";

export default {
  components: {
    ProductBrandListComponent
  }
}
